interface SlideOptions {
	element: Element;
	isActive?: boolean;
}

export default class CarouselSlide {
	public element: Element;
	public isActive = false;
	public isOutgoing = false;

	constructor({ element, isActive }: SlideOptions) {
		this.element = element;
		this.isActive = isActive || false;
	}
	public activate = () => {
		this.element.setAttribute('data-status', 'active');
		this.isActive = true;
		this.isOutgoing = false;
	}
	public deactivate = () => {
		this.element.setAttribute('data-status', 'outgoing');
		this.isActive = false;
		this.isOutgoing = true;
	}
	public clear = () => {
		this.element.setAttribute('data-status', '');
		this.isOutgoing = false;
	}
}
